<template>
<div id="subscription-edit">
  <h2>Edit Subscription #{{ subscriptionId }}</h2>

  <subscription-form
    :subscriptionId="subscriptionId"
  ></subscription-form>
</div>
</template>

<script>
import SubscriptionForm from '@/components/SubscriptionForm'

export default {
  components: {
    'subscription-form': SubscriptionForm
  },

  props: ['subscriptionId']
}
</script>



// WEBPACK FOOTER //
// src/components/SubscriptionEdit.vue